import { Button } from "@/components/Button";
import { ModalBackdrop } from "@/components/Modal/GenericModal";
import { LuStore } from "react-icons/lu";
import styled from "styled-components";

// Fixo na área visível: aparece onde a pessoa está, sem rolar a página.
const Backdrop = styled(ModalBackdrop)`
    position: fixed;
    inset: 0;
    align-items: center;
    padding: 1rem 0;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 31.25rem;
    max-width: calc(100% - 2rem);
    padding: 1.5rem;
    gap: 1rem;
    flex-shrink: 0;
    border-radius: 1.5rem;
    border: 1px solid var(--Neutral-200, #e4e4e7);
    background: var(--Neutral-50, #fafafa);
    margin: auto;
    text-align: center;

    svg {
        width: 3rem;
        height: 3rem;
        color: #e23a81;
    }

    p.date {
        color: var(--BLUE, #195da5);
        font-family: Poppins;
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 600;
        line-height: 1.2rem;
    }

    p.title {
        color: #e23a81;
        font-family: Poppins;
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 700;
        line-height: 1.5rem;
    }

    > button {
        width: 100%;
    }
`;

export const SalesClosedModal = ({
    formattedDate,
    message,
    handleClose,
}: {
    formattedDate: string;
    message: string;
    handleClose: () => void;
}) => {
    return (
        <Backdrop
            className="ignore-padding"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.1 }}
            onClick={handleClose}
        >
            <Container
                onClick={(e) => e.stopPropagation()}
                role="alertdialog"
                aria-labelledby="sales-closed-modal-title"
            >
                <LuStore />
                <p className="date">{formattedDate}</p>
                <p className="title" id="sales-closed-modal-title">
                    {message}
                </p>
                <Button
                    onClick={handleClose}
                    children="Entendi"
                    $variant="blue"
                    $font="poppins"
                    $animationLevel={["constrast", "reduce-scale"]}
                />
            </Container>
        </Backdrop>
    );
};
